import React from 'react';
import { Typography, Box, Paper, List, ListItem, ListItemText, ListItemIcon,useTheme } from '@mui/material';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import SchoolIcon from '@mui/icons-material/School';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import Footer from './footer';

function SkillsSection() {
  const theme = useTheme();
  const paper = theme.palette.mode === 'dark' ? '#FFC300' : '#ffffff';
  const list = theme.palette.mode === 'dark' ? '#ffffff ' : '#26E113 ';
  const typograph = theme.palette.mode === 'dark' ? '#FFC300' : '#000000';
  return (
    <Box sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ p: 3, mb: 3, color:paper }}>
        <Typography variant="h5" sx={{color:typograph}} gutterBottom>
          Technical Skills.
        </Typography>
        <List>
          <ListItem >
            <ListItemIcon>
              <DeveloperModeIcon />
            </ListItemIcon>
            <ListItemText primary="Oracle Databases/the autonomous database/PostgreSQL/MySQL." sx={{color:list}} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <DeveloperModeIcon />
            </ListItemIcon>
            <ListItemText primary="Prototyping using figma." sx={{color:list}} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <DeveloperModeIcon />
            </ListItemIcon>
            <ListItemText primary="Computer skills/ms word,powerpont,spreadsheet." sx={{color:list}} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <DeveloperModeIcon />
            </ListItemIcon>
            <ListItemText primary="User experience design skills." sx={{color:list}} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <DeveloperModeIcon />
            </ListItemIcon>
            <ListItemText primary="Responsive Design using material ui theme and styles." sx={{color:list}}/>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <DeveloperModeIcon />
            </ListItemIcon>
            <ListItemText primary="CSS, HTML 5, oracle APEX app,oracle Jet,python." sx={{color:list}}/>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <DeveloperModeIcon />
            </ListItemIcon>
            <ListItemText primary="JavaScript frameworks ( Reactjs,angular)." sx={{color:list}} />
          </ListItem>
        </List>
      </Paper>

      <Paper elevation={3} sx={{ p: 3, mb: 3, color:paper }}>
        <Typography variant="h5" sx={{color:typograph}} gutterBottom>
          Soft Skills.
        </Typography>
        <List>
          <ListItem>
            <ListItemIcon>
              <SchoolIcon />
            </ListItemIcon>
            <ListItemText primary="Communication." sx={{color:list}}/>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <SchoolIcon />
            </ListItemIcon>
            <ListItemText primary="Leadership." sx={{color:list}}/>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <SchoolIcon />
            </ListItemIcon>
            <ListItemText primary="Interpersonal." sx={{color:list}}/>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <SchoolIcon />
            </ListItemIcon>
            <ListItemText primary="Teamwork." sx={{color:list}} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <SchoolIcon />
            </ListItemIcon>
            <ListItemText primary="Time Management." sx={{color:list}} />
          </ListItem>
        </List>
      </Paper>

      <Paper elevation={3} sx={{ p: 3, mb: 3, color:paper }}>
        <Typography variant="h5" sx={{color:typograph}} gutterBottom>
          Certifications & Training.
        </Typography>
        <List>
          <ListItem>
            <ListItemIcon>
              <CardMembershipIcon />
            </ListItemIcon>
            <ListItemText primary="African Leadership Engineering Program Software Engineering/ALX (ongoing)." sx={{color:list}} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CardMembershipIcon />
            </ListItemIcon>
            <ListItemText primary="Linux Unhatched (Coursera)." sx={{color:list}} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CardMembershipIcon />
            </ListItemIcon>
            <ListItemText primary="Introduction to Data Science (Cisco)." sx={{color:list}}/>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CardMembershipIcon />
            </ListItemIcon>
            <ListItemText primary="Introduction to Cybersecurity (Coursera)." sx={{color:list}} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CardMembershipIcon />
            </ListItemIcon>
            <ListItemText primary="Cisco Certified Network Associate (CCNA)." sx={{color:list}}/>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CardMembershipIcon />
            </ListItemIcon>
            <ListItemText primary="Foundation of User Experience and Google UX Design Professional Certificate(COURSERA)." sx={{color:list}}/>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CardMembershipIcon />
            </ListItemIcon>
            <ListItemText primary="System Administration and IT Infrastructure Services(COURSERA)." sx={{color:list}} />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CardMembershipIcon />
            </ListItemIcon>
            <ListItemText primary="Google Project Management(COURSERA)." sx={{color:list}}/>
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <CardMembershipIcon />
            </ListItemIcon>
            <ListItemText primary="Introduction to a Relational Database(COURSERA)." sx={{color:list}}/>
          </ListItem>
        </List>
      </Paper>

      <Footer />
    </Box>
  );
}

export default SkillsSection;
